<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div style="display: flex; padding-top: 10px;">
			<div>剩余下载次数：</div>
			<div>{{list.num}}</div>
			
		</div>
		<div style="display: flex; padding-top: 10px;">
			<el-button type="primary" @click="onSubmit(1)" size="mini">添加1次</el-button>
			<el-button type="primary" @click="onSubmit(5)" size="mini">添加5次</el-button>
			<el-button type="primary" @click="onSubmit(10)" size="mini">添加10次</el-button>
			<el-button type="primary" @click="onSubmit(20)" size="mini">添加20次</el-button>
			<el-button type="danger" @click="onSubmit(0)" size="mini">次数归零</el-button>
		</div>
		<div style="display: flex; padding-top: 10px;padding-bottom: 50px;">
			<div>已下载次数：</div>
			<div>{{list.num_yx}}</div>
		</div>

	</div>
</template>

<script>
	import common from '@/common/mixins/common.js'; // 引入 全局共公样式
	import buttonSearch from '@/components/common/button-search.vue';
	import {
		mapState
	} from 'vuex'; // 引入 全局 公共数据
	export default {
		mixins: [common], // 引入mixins里的common.js
		inject: ['layout'], // 依赖注入
		data() {
			return {
				list:{}
			};
		},
		components: {
			buttonSearch
		},
		computed: {
			...mapState({
				user: state => state.user.user
			})
		},
		mounted() {
			this.getlists()
		},
		methods: {
			getlists(){
				this.axios.get('/admin/xtxz/list', {
						token: true
					}).then(res => {
						this.list = res.data.data
					});
			},
			onSubmit(e){
				this.axios.get('/admin/xtxz/xgcs/'+e, {
						token: true
					}).then(res => {
						this.$message({
							type: 'success',
							message: '操作成功'
						});
						this.getlists()
					});
			}

		}
	};
</script>

<style></style>